const themes = {
  light: {
    "--toggle": "hsl(230, 22%, 74%)",
    "--bg-color": "hsl(0, 0%, 100%)",
    "--top-bg-pattern-color": "hsl(225, 100%, 98%)",
    "--card-bg-color": "hsl(227, 47%, 96%)",
    "--font-color-1": "hsl(228, 12%, 44%)",
    "--font-color-2": "hsl(230, 17%, 14%)",
    "--header-border-bottom": "hsl(230, 19%, 60%)",
    "--card-bg-color-hover": "#E1E4F0",
  },
  dark: {
    "--toggle": "linear-gradient(hsl(210, 78%, 56%), hsl(146, 68%, 55%))",
    "--bg-color": "hsl(230, 17%, 14%)",
    "--top-bg-pattern-color": "hsl(232, 19%, 15%)",
    "--card-bg-color": "hsl(228, 28%, 20%)",
    "--font-color-1": "hsl(228, 34%, 66%)",
    "--font-color-2": "hsl(0, 0%, 100%)",
    "--header-border-bottom": "hsl(228, 25%, 27%)",
    "--card-bg-color-hover": "#333A55",
  },
};

export default themes;
